import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { ivrBlockingSVG } from '../../../Images/IVRSVG';

Modal.setAppElement('body');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    bottom: 'auto',
    width: '180px',
    height: 'auto',
    overflow: 'hidden',
    padding: '0',

    transform: 'translate(-50%, -50%)'
  }
};

export const OngoingCallIvrModal = (props) => {
  const {
    isModalOpen,
    data
  } = props;


  return (
    <Modal 
      className="Ongoing"
      isOpen={isModalOpen}
      style={customStyles}>
      <div className="OngoingCallIvrModalHeader">
        <div className="ValidatingAnimation">
          <div className="circle1"></div>
          <div className="circle2"></div>
          <div className="ivrAnimation">{ivrBlockingSVG}</div>
          {/* <Image src={this.state.timeOut ? invalidTelephony : this.state.telephonyValid ? validTelephony : validatingTelephony }
            className="animationValidating"/> */}
        </div>
      </div>
      <div className="OngoingCallIvrModalMessageContainer">
        <div className="OngoingCallIvrModalTitle">{data.title}</div>
        <div className="OngoingCallIvrModalMessage">{data.message}</div>            
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  const { isModalOpen, data } = state.isOngoingCallIvrModalOpen;
  return {
    isModalOpen,
    data
  };
};

export default connect(mapStateToProps, null)(OngoingCallIvrModal);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/OngoingCallIvrModal.jsx